/** @import { OptionalComponentConfig } from "../types/optionalComponentConfig.d.ts" */
/**
 * @param {OptionalComponentConfig | undefined} config 
 * @returns {boolean} isEnabled
 */
export default function isEnabled(config) {
    return (config != undefined) && config.enable
}